import { FontFamilyByWeight } from "./types";

export const InterFontProps: FontFamilyByWeight = {
  400: {
    fontFamily: "Inter_400Regular",
    fontWeight: 400,
    "$web-fontFamily": "Inter"
  },
  500: {
    fontFamily: "Inter_500Medium",
    fontWeight: 500,
    "$web-fontFamily": "Inter"
  },
  600: {
    fontFamily: "Inter_600SemiBold",
    fontWeight: 600,
    "$web-fontFamily": "Inter"
  },
  700: {
    fontFamily: "Inter_700Bold",
    fontWeight: 700,
    "$web-fontFamily": "Inter"
  },
  800: {
    fontFamily: "Inter_800ExtraBold",
    fontWeight: 800,
    "$web-fontFamily": "Inter"
  },
  900: {
    fontFamily: "Inter_900Black",
    fontWeight: 900,
    "$web-fontFamily": "Inter"
  }
};

export const RobotoFontProps: FontFamilyByWeight = {
  400: {
    fontFamily: "Roboto_400Regular",
    fontWeight: 400,
    "$web-fontFamily": "Roboto"
  },
  500: {
    fontFamily: "Roboto_500Medium",
    fontWeight: 500,
    "$web-fontFamily": "Roboto"
  },
  600: {
    fontFamily: "Roboto_500Medium",
    fontWeight: 600,
    "$web-fontFamily": "Roboto"
  },
  700: {
    fontFamily: "Roboto_700Bold",
    fontWeight: 700,
    "$web-fontFamily": "Roboto"
  },
  800: {
    fontFamily: "Roboto_800ExtraBold",
    fontWeight: 800,
    "$web-fontFamily": "Roboto"
  },
  900: {
    fontFamily: "Roboto_900Black",
    fontWeight: 900,
    "$web-fontFamily": "Roboto"
  }
};
